@if (ready) {
  <se-fe-card class="persona-choice" [ngClass]="{ 'disabled': profileFrame?.disable }">
    @if (profileFrame?.header) {
      <se-fe-alert seFeDataType="{{profileFrame?.header?.type}}">
        {{profileFrame?.header?.text}}
      </se-fe-alert>
    }
    <se-fe-card-content>
      <div class="persona-choice-content">
        <se-fe-header
          [ngClass]="{ 'missing-info': missingInfo }"
          (click)="handleHeaderClick($event)"
          (keydown)="onKeydown($event)" tabindex="0"
          class="persona-header se-fe-theme--interactive"
          [seFeDataTitle]="profile?.persona?.full_name"
          [seFeDataTitleTruncate]="true"
          [seFeDataSubtitle]="subtitle"
          [seFeDataLevel]="0"
          [seFeDataSize]="600">
          <se-fe-avatar
            seFeHeaderVisual
            seFeDataType="persona"
            [seFeDataIdentity]="profile?.persona?.full_name"
            [seFeDataImgUrl]="imageUrl"
            [seFeDataSize]="300">
          </se-fe-avatar>
        </se-fe-header>
        <div>
          <se-fe-button
            class="edit-button"
            (click)="onEdit($event)"
            seFeDataEmphasis="low">
            {{ 'SE_PO_UI_PERSONA_CHOICE.EDIT' | translate }}
          </se-fe-button>
        </div>
      </div>
    </se-fe-card-content>
    @if (profileFrame?.actions?.length > 0) {
      <div class="actions">
        @for (action of profileFrame?.actions; track action) {
          <se-fe-button
            class="choose-button"
            (click)="onAction({name: action.name})"
            seFeDataFullWidth="true">
            {{ action.label }}
          </se-fe-button>
        }
      </div>
    }
  </se-fe-card>
}
